import styled from '@emotion/styled'
import { Button } from 'driverama-core/components/button/Button'

export const SButton = styled(Button)`
  width: 100%;
`
